<template>
  <div>
    <!-- #region 後台選單 -->
    <v-item-group active-class="primary" v-model="admin" mandatory>
      <v-container class="mt-8">
        <v-row class="d-flex justify-center">
          <v-col v-for="x in adminItem" :key="x" cols="4">
            <v-item v-slot="{ active, toggle }">
              <v-card class="d-flex align-center grey lighten-1" dark height="100" @click="toggle">
                <v-scroll-y-transition>
                  <div v-if="active" class="text-h3 flex-grow-1 text-center font-weight-black">{{ x }}</div>
                  <div v-else class="text-h5 flex-grow-1 text-center">{{ x }}</div>
                </v-scroll-y-transition>
              </v-card>
            </v-item>
          </v-col>
        </v-row>
      </v-container>
    </v-item-group>

    <!-- #endregion -->

    <!-- #region 廣告 -->
    <template v-if="adDataLoading">
      <v-container class="my-10" style="min-width: 1600px">
        <v-progress-linear indeterminate color="primary"></v-progress-linear>
      </v-container>
    </template>
    <template v-else>
      <v-container v-if="admin === 0" class="my-10" style="min-width: 1600px">
        <v-expansion-panels v-model="panels">
          <v-expansion-panel v-for="x in data" :key="x.id">
            <v-expansion-panel-header class="d-flex">
              <span style="width: 100px" class="mr-2 ellipsis"> {{ x.applyName }} </span>
              <span style="width: 120px" class="mr-2 ellipsis"> {{ x.applyPhone }} </span>
              <span style="width: 200px" class="mr-2 ellipsis"> {{ x.applyEmail }} </span>
              <span style="width: 240px" class="mr-2 ellipsis"> {{ x.applyCompany }} </span>
              <span style="width: 200px" class="mr-2 ellipsis"> <span class="grey--text mr-1 text-body-2"> (介紹)</span>{{ x.introducer }} </span>
              <span style="width: 200px" class="mr-2 ellipsis"> <span class="grey--text mr-1 text-body-2"> (顧問)</span>{{ x.consultant }} </span>
              <span style="width: 200px" class="mr-2 ellipsis"> {{ formatDateNoTime(x.createDate) }} </span>
              <span>
                <v-chip class="mr-2" :color="x.online ? 'success' : 'error'"> {{ x.online ? '上架中' : '未上架' }} </v-chip>
              </span>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-row class="my-2">
                <v-col cols="12">
                  <v-divider></v-divider>
                </v-col>

                <v-col cols="4" class="d-flex">
                  <div class="mr-2">申請人姓名 :</div>
                  <div class="font-weight-black">{{ x.applyName }}</div>
                </v-col>
                <v-col cols="4" class="d-flex">
                  <div class="mr-2">申請人電話 :</div>
                  <div class="font-weight-black">{{ x.applyPhone }}</div>
                </v-col>
                <v-col cols="4" class="d-flex">
                  <div class="mr-2">申請人信箱 :</div>
                  <div class="font-weight-black">{{ x.applyEmail }}</div>
                </v-col>
                <v-col cols="4" class="d-flex">
                  <div class="mr-2">申請人公司 :</div>
                  <div class="font-weight-black">{{ x.applyCompany }}</div>
                </v-col>
                <v-col cols="4" class="d-flex">
                  <div class="mr-2">申請日期 :</div>
                  <div class="font-weight-black">{{ formatDate(x.createDate) }}</div>
                </v-col>

                <v-col cols="12">
                  <v-divider></v-divider>
                </v-col>

                <v-col cols="8" class="d-flex">
                  <div class="mr-2">申請人地址 :</div>
                  <div class="font-weight-black">{{ x.applyAddress }}</div>
                </v-col>
                <v-col cols="4" class="d-flex">
                  <div class="mr-2">介紹人 :</div>
                  <div class="font-weight-black">{{ x.introducer }}</div>
                </v-col>
                <v-col cols="4" class="d-flex">
                  <div class="mr-2">顧問師 :</div>
                  <div class="font-weight-black">{{ x.consultant }}</div>
                </v-col>
                <v-col cols="4" class="d-flex">
                  <div class="mr-2">是否為金豐客戶 :</div>
                  <div class="font-weight-black">{{ x.kfCustomer ? '是' : '否' }}</div>
                </v-col>
                <v-col cols="4" class="d-flex">
                  <div class="mr-2">排序 :</div>
                  <div class="font-weight-black">{{ x.sort }}</div>
                </v-col>
                <v-col cols="4" class="d-flex">
                  <div class="mr-2">開始日期 :</div>
                  <div class="font-weight-black">{{ formatDate(x.startDate) }}</div>
                </v-col>
                <v-col cols="4" class="d-flex">
                  <div class="mr-2">結束日期 :</div>
                  <div class="font-weight-black">{{ formatDate(x.endDate) }}</div>
                </v-col>
                <v-col cols="4" class="d-flex">
                  <div class="mr-2">更新日期 :</div>
                  <div class="font-weight-black">{{ x.updateDate }}</div>
                </v-col>
                <v-col cols="4" class="d-flex">
                  <div class="mr-2">廣告預算 :</div>
                  <div class="font-weight-black">{{ x.advertiseBudget }}</div>
                </v-col>

                <v-col cols="12">
                  <v-divider></v-divider>
                </v-col>

                <v-col cols="6" class="d-flex align-center">
                  <div class="mr-2">意願調查 :</div>
                  <div v-for="y in x.advertiseQuestionnaireList" :key="y">
                    <v-chip>{{ y }}</v-chip>
                  </div>
                </v-col>
                <v-col cols="6" class="d-flex align-center">
                  <div class="mr-2">上架服務 :</div>
                  <div v-for="y in x.adServicesList" :key="y">
                    <v-chip class="mr-1 font-weight-black">{{ y }}</v-chip>
                  </div>
                </v-col>
                <v-col cols="6" class="d-flex align-center">
                  <div class="mr-2">廣告地區 :</div>
                  <div v-for="y in x.advertiseAreaList" :key="y">
                    <v-chip class="mr-1 font-weight-black">{{ y }}</v-chip>
                  </div>
                </v-col>
                <v-col cols="6" class="d-flex align-center">
                  <div class="mr-2">廣告行政區 :</div>
                  <div v-for="y in x.advertiseDistrictList" :key="y">
                    <v-chip class="mr-1 font-weight-black">{{ y }}</v-chip>
                  </div>
                </v-col>
                <v-col cols="6" class="d-flex align-center">
                  <div class="mr-2">廣告類別 :</div>
                  <div v-for="y in x.advertiseCategoryList" :key="y">
                    <v-chip class="mr-1 font-weight-black">{{ y }}</v-chip>
                  </div>
                </v-col>

                <v-col cols="12" class="d-block align-center text-left">
                  <div class="mr-2 mb-4">行業別代號 :</div>
                  <v-row>
                    <v-col cols="1" v-for="y in x.companyIndustryCodeList" :key="y">
                      <v-chip class="mr-1 font-weight-black">{{ y }}</v-chip>
                    </v-col>
                  </v-row>
                </v-col>

                <v-col cols="12">
                  <v-divider></v-divider>
                </v-col>

                <v-col cols="6" class="d-flex align-center">
                  <div class="mr-2">圖片標題 :</div>
                  <div class="font-weight-black">{{ x.imgTitle }}</div>
                </v-col>
                <v-col cols="6" class="d-flex align-center">
                  <div class="mr-2">圖片說明 :</div>
                  <div class="font-weight-black">{{ x.imgContent }}</div>
                </v-col>
                <v-col cols="6" class="d-flex align-center">
                  <div class="mr-2">廣告圖1 :</div>
                  <a :href="x.imgCustom1">{{ x.imgCustom1 }}</a>
                </v-col>
                <v-col cols="2" class="d-flex align-center">
                  <v-img :src="x.imgCustom1" contain></v-img>
                </v-col>
                <v-col cols="6" class="d-flex align-center">
                  <div class="mr-2">廣告圖2 :</div>
                  <a :href="x.imgCustom2">{{ x.imgCustom2 }}</a>
                </v-col>
                <v-col cols="2" class="d-flex align-center">
                  <v-img :src="x.imgCustom2" contain></v-img>
                </v-col>

                <v-col cols="12">
                  <v-divider></v-divider>
                </v-col>

                <v-col cols="6" class="d-flex align-center">
                  <div class="mr-2">廣告圖LG :</div>
                  <a :href="x.imgLg">{{ x.imgLg }}</a>
                </v-col>
                <v-col cols="6" class="d-flex align-center">
                  <v-img :src="x.imgLg" contain></v-img>
                </v-col>
                <v-col cols="6" class="d-flex align-center">
                  <div class="mr-2">廣告圖MD :</div>
                  <a :href="x.imgMd">{{ x.imgMd }}</a>
                </v-col>
                <v-col cols="6" class="d-flex align-center">
                  <v-img :src="x.imgMd" contain></v-img>
                </v-col>
                <v-col cols="6" class="d-flex align-center">
                  <div class="mr-2">廣告圖SM :</div>
                  <a :href="x.imgSm">{{ x.imgSm }}</a>
                </v-col>
                <v-col cols="6" class="d-flex align-center">
                  <div>
                    <v-img :src="x.imgSm" contain></v-img>
                  </div>
                </v-col>

                <v-col cols="12">
                  <v-divider></v-divider>
                </v-col>

                <v-col cols="6" class="text-left my-4">
                  <div class="mb-4">廣告ID : {{ x.applyId }}</div>
                  <v-btn color="primary" @click="uploadImg(x.applyId)">上傳圖片</v-btn>
                </v-col>
                <v-col cols="6" class="text-left my-4">
                  <div class="mb-4 d-flex align-center">
                    <span class="mr-2">狀態 : </span> <v-chip class="mr-2" small :color="x.online ? 'success' : 'error'"> {{ x.online ? '上架中' : '未上架' }} </v-chip>
                  </div>
                  <div v-if="x.imgLG === '' || x.imgMd === '' || x.imgSm === ''">
                    <v-btn disabled>{{ x.online ? '下架廣告' : '上架廣告' }}</v-btn>
                    <span class="text-body-2 ml-4">( 無三張廣告圖無法上下架 )</span>
                  </div>
                  <div v-else>
                    <v-btn :color="x.online ? 'error' : 'success'" :loading="loading" @click="onlineAds(x.applyId)">{{ x.online ? '下架廣告' : '上架廣告' }}</v-btn>
                  </div>
                </v-col>
                <v-col cols="12" class="text-left mt-8">
                  <v-btn color="warning" large @click="deleteAds(x.applyId)">刪除廣告</v-btn>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-container>
    </template>

    <v-dialog v-model="dialog" width="500">
      <v-card>
        <v-card-title class="font-weight-black">
          <div>更新廣告圖</div>
          <v-spacer></v-spacer>
          <v-btn icon @click="dialog = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>

        <v-card-text class="mt-4">
          <div class="mb-2 error--text">ID : {{ selectedId }}</div>
          <div class="mb-4">談窗關閉不會將圖片移除，更新資料以ID為準</div>
          <v-form ref="form">
            <v-file-input v-model="files.lg" label="LG" hide-detail="auto" :rules="rules" outlined accept="image/*"></v-file-input>
            <v-file-input v-model="files.md" label="MD" hide-detail="auto" :rules="rules" outlined accept="image/*"></v-file-input>
            <v-file-input v-model="files.sm" label="SM" required hide-detail="auto" :rules="rules" outlined accept="image/*"></v-file-input>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="updateAds()" :loading="loading2"> 更新 </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog2" width="500">
      <v-card>
        <v-card-title class="font-weight-black">
          <div>確定刪除廣告嗎</div>
          <v-spacer></v-spacer>
          <v-btn icon @click="dialog2 = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>

        <v-card-text class="mt-6">
          <div class="mb-2 error--text">ID : {{ selectedId }}</div>
          <div class="text-h6 warning--text font-weight-black">* 廣告刪除後將無法回復</div>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="deleteAdsApi()" :loading="loading3"> 刪除 </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- #endregion -->

    <!-- #region 社群 -->
    <template v-if="communityDataLoading">
      <v-container class="my-10" style="min-width: 1600px">
        <v-progress-linear indeterminate color="primary"></v-progress-linear>
      </v-container>
    </template>
    <template v-else>
      <v-container v-if="admin === 1 && smsData.length > 0" class="my-10" style="min-width: 1600px">
        <v-data-table :headers="tableHeaders" :items="smsData" :single-expand="singleExpand" :expanded.sync="expanded" item-key="id" show-expand class="elevation-1">
          <template v-slot:top>
            <v-toolbar flat>
              <v-toolbar-title class="font-weight-black">
                社群總數：
                <span class="text-h4 font-weight-black primary--text">{{ smsData.length }}</span>
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-switch v-model="singleExpand" label="單行展開" class="mt-2"></v-switch>
            </v-toolbar>
          </template>

          <template v-slot:item.createdDate="{ item }">
            {{ formatDateNoTime(item.createdDate) }}
          </template>
          <template v-slot:item.updateDate="{ item }">
            {{ formatDateNoTime(item.updateDate) }}
          </template>
          <template v-slot:item.isPublic="{ item }">
            <v-chip :color="item.isPublic ? 'success' : 'grey'" dark>
              {{ item.isPublic ? '公開中' : '非公開' }}
            </v-chip>
          </template>
          <template v-slot:item.isClosed="{ item }">
            <v-chip v-if="item.isClosed" color="warning" dark> 關閉中 </v-chip>
          </template>
          <template v-slot:item.isMothball="{ item }">
            <v-chip v-if="item.isMothball" color="error" dark> 封存中 </v-chip>
          </template>
          <template v-slot:item.url="{ item }">
            <a :href="communityUrl(item.id)" target="_blank">社群連結</a>
          </template>
          <template v-slot:item.action="{ item }">
            <v-btn v-if="!item.isMothball" @click="mothball(item.id)" color="error" outlined>封存</v-btn>
            <v-btn v-else @click="Community_UnmothballApi(item.id)" class="white--text" color="primary">解封</v-btn>
          </template>

          <template v-slot:expanded-item="{ header, item }">
            <div class="my-4 ml-2 text-left">
              <div class="my-2 text-h6 font-weight-black">地區</div>
              <div class="d-flex pr-2 mb-4">
                <v-chip class="mr-2" v-for="x in item.areaList" :key="x + 'area'">{{ x }} </v-chip>
              </div>
              <div class="my-2 text-h6 font-weight-black">類型</div>
              <div class="d-flex pr-2 mb-4">
                <v-chip class="mr-2" v-for="y in item.typeList" :key="y + 'type'">{{ y }} </v-chip>
              </div>
              <div class="my-2 text-h6 font-weight-black">創建人資料</div>
              <div class="mb-2"><span class="mr-1"> 姓名 :</span> {{ item.ownerName }}</div>
              <div class="mb-2"><span class="mr-1"> 電話 :</span>{{ item.ownerPhone }}</div>
              <div class="mb-4"><span class="mr-1"> 信箱 :</span>{{ item.ownerEmail }}</div>
            </div>
          </template>
        </v-data-table>
      </v-container>
    </template>

    <v-dialog v-model="dialog3" width="500">
      <v-card>
        <v-card-title class="font-weight-black">
          <div>確定封存該社群嗎</div>
          <v-spacer></v-spacer>
          <v-btn icon @click="dialog3 = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>

        <v-card-text class="mt-6">
          <div class="mb-2 text-h6">封存後會寄信通知所有社群成員</div>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="Community_MothballApi()" :loading="loading4"> 封存 </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- #endregion -->

    <!--  #region 提示條 -->
    <v-snackbar top v-model="snackbar.show" :color="snackbar.color">
      {{ snackbar.content }}
      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snackbar.show = false">
          {{ snackbar.close }}
        </v-btn>
      </template>
    </v-snackbar>
    <!-- #endregion -->

    <!--  #region 提示條2 -->
    <v-snackbar top v-model="snackbar2.show" :color="snackbar2.color">
      {{ snackbar2.content }}
      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snackbar2.show = false">
          {{ snackbar2.close }}
        </v-btn>
      </template>
    </v-snackbar>
    <!-- #endregion -->
  </div>
</template>

<script>
/* eslint-disable */
import {
  Advertise_Get_ManageList,
  Advertise_Post_OnlineAds,
  Advertise_Post_UpdateImage,
  Advertise_Delete,
  SMS_GetCommunityList,
  Community_Mothball,
  Community_MothballCommunityAdminSendMails,
  Community_Unmothball,
} from '@/apis/api.js';
export default {
  data() {
    return {
      admin: null,
      adminItem: ['廣告管理', '社群管理'],

      //#region 廣告
      pwd: 'kingfongit001',
      success: false,
      panels: null,
      data: [],
      updateId: null,
      dialog: false,
      dialog2: false,
      loading: false,
      loading2: false,
      loading3: false,
      adDataLoading: false,
      files: {
        lg: null,
        md: null,
        sm: null,
      },
      selectedId: null,
      rules: [(v) => !!v || '此欄位必填'],
      //#endregion

      // #region 社群
      dialog3: false,
      loading4: false,
      communityDataLoading: false,
      selectedCommunityId: null,
      smsData: [],
      expanded: [],
      singleExpand: true,
      tableHeaders: [
        // { text: '編號', align: 'start', sortable: false, value: 'id' },
        {
          text: '社群名稱',
          align: 'start',
          sortable: false,
          value: 'name',
        },
        { text: '', value: 'data-table-expand' },
        { text: '擁有者', value: 'ownerName', width: 100 },
        { text: '建立日期', value: 'createdDate', width: 120 },
        { text: '社群人數', value: 'userTotal', width: 100 },
        { text: '介紹人/電話', value: 'recommender' },
        { text: '顧問/電話', value: 'consultant' },
        { text: '是否公開', value: 'isPublic', width: 100 },
        { text: '是否關閉', value: 'isClosed', width: 100 },
        { text: '是否封存', value: 'isMothball', width: 100 },
        { text: '更新日期', value: 'updateDate', width: 120 },
        { text: '網站連結', value: 'url', width: 120 },
        { text: '封存社群', value: 'action', width: 120 },
      ],
      // #endregion

      snackbar: {
        show: false,
        content: '',
        color: '',
        close: '關閉',
      },
      snackbar2: {
        show: false,
        content: '',
        color: '',
        close: '關閉',
      },
    };
  },
  created() {
    let ans = prompt('請輸入密碼', '');
    if (ans === this.pwd) {
      this.success = true;
      return;
    }
    this.$router.push({ name: 'Home' });
  },
  mounted() {
    if (this.success && this.admin === '廣告管理') {
      this.getAdsListApi();
    }
  },
  watch: {
    admin(newVal) {
      if (newVal === 0) {
        this.getAdsListApi();
      }
      if (newVal === 1) {
        this.getCommunityListApi();
      }
    },
  },
  methods: {
    // #region 廣告
    onlineAds(applyId) {
      this.loading = true;
      Advertise_Post_OnlineAds(applyId)
        .then((res) => {
          console.log(res);
          this.snackbar.content = '更新成功';
          this.snackbar.color = 'success';
        })
        .catch((err) => {
          console.error(err);
          this.snackbar.content = '更新失敗';
          this.snackbar.color = 'error';
        })
        .finally(() => {
          this.loading = false;
          this.snackbar.show = true;
          this.getAdsListApi();
        });
    },
    updateAds() {
      let valid = this.$refs.form.validate();
      if (valid === false) {
        return;
      }

      this.loading2 = true;

      let formData = new FormData();
      formData.append('Lg', this.files.lg);
      formData.append('Md', this.files.md);
      formData.append('Sm', this.files.sm);

      Advertise_Post_UpdateImage(this.selectedId, formData)
        .then((res) => {
          console.log(res);
          this.snackbar.content = '更新成功';
          this.snackbar.color = 'success';
        })
        .catch((err) => {
          console.error(err);
          this.snackbar.content = '更新失敗';
          this.snackbar.color = 'error';
        })
        .finally(() => {
          this.loading2 = false;
          this.snackbar.show = true;
          this.dialog = false;
          this.getAdsListApi();
        });
    },
    uploadImg(applyId) {
      this.dialog = true;
      this.selectedId = applyId;
    },
    deleteAds(applyId) {
      this.dialog2 = true;
      this.selectedId = applyId;
    },
    deleteAdsApi() {
      this.loading3 = true;
      Advertise_Delete(this.selectedId)
        .then((res) => {
          console.log(res);
          this.snackbar.content = '刪除成功';
          this.snackbar.color = 'success';
        })
        .catch((err) => {
          console.error(err);
          this.snackbar.content = '刪除失敗';
          this.snackbar.color = 'error';
        })
        .finally(() => {
          this.loading3 = false;
          this.snackbar.show = true;
          this.dialog2 = false;
          this.panels = null;
          this.getAdsListApi();
        });
    },
    getAdsListApi() {
      this.adDataLoading = true;

      Advertise_Get_ManageList()
        .then((res) => {
          console.log(res);
          this.data = res.data.data;
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          this.adDataLoading = false;
        });
    },
    formatDate(dateStr) {
      if (dateStr === null) {
        return '';
      }
      const date = new Date(dateStr);
      const pad = (num) => String(num).padStart(2, '0');

      const year = date.getFullYear();
      const month = pad(date.getMonth() + 1);
      const day = pad(date.getDate());
      const hours = pad(date.getHours());
      const minutes = pad(date.getMinutes());
      const seconds = pad(date.getSeconds());

      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    formatDateNoTime(dateStr) {
      if (dateStr === null) {
        return '';
      }
      const date = new Date(dateStr);
      const pad = (num) => String(num).padStart(2, '0');

      const year = date.getFullYear();
      const month = pad(date.getMonth() + 1);
      const day = pad(date.getDate());

      return `${year}-${month}-${day}`;
    },
    previewImage() {
      const url = document.getElementById('imageUrl').value;
      const imageContainer = document.getElementById('imageContainer');

      imageContainer.innerHTML = '';

      const img = document.createElement('img');
      img.src = url;
      img.alt = 'Image Preview';
      img.className = 'image-preview';

      // Append the img element to the container
      imageContainer.appendChild(img);
    },
    // #endregion

    // #region 社群
    getCommunityListApi() {
      this.communityDataLoading = true;
      SMS_GetCommunityList()
        .then((res) => {
          console.log(res.data.data);
          let entity = res.data.data;

          entity.forEach((x) => {
            if (x.owner !== null) {
              x.ownerName = x.owner.name;
              x.ownerPhone = x.owner.phone;
              x.ownerEmail = x.owner.email;
            }
          });

          this.smsData = entity;
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          this.communityDataLoading = false;
        });
    },
    communityUrl(id) {
      return process.env.VUE_APP_MAIN_SMS_BASE_URL + '/communityHome?cmid=' + id;
    },
    mothball(id) {
      this.selectedCommunityId = id;

      this.dialog3 = true;
    },
    Community_MothballApi() {
      this.loading4 = true;
      Community_Mothball(this.selectedCommunityId)
        .then((res) => {
          console.log(res);
          this.snackbar.content = '已封存';
          this.snackbar.color = 'success';
        })
        .catch((err) => {
          console.error(err);
          this.snackbar.content = '封存失敗';
          this.snackbar.color = 'error';
        })
        .finally(() => {
          this.snackbar.show = true;
          this.loading4 = false;
          this.dialog3 = false;
          this.getCommunityListApi();
          this.Community_MothballCommunityAdminSendMailsApi();
        });
    },
    Community_MothballCommunityAdminSendMailsApi() {
      Community_MothballCommunityAdminSendMails(this.selectedCommunityId)
        .then((res) => {
          console.log(res);
          this.snackbar2.content = '已送出通知信';
          this.snackbar2.color = 'success';
        })
        .catch((err) => {
          console.error(err);
          this.snackbar2.content = '送信失敗';
          this.snackbar2.color = 'error';
        })
        .finally(() => {
          this.snackbar2.show = true;
        });
    },
    Community_UnmothballApi(id) {
      Community_Unmothball(id)
        .then((res) => {
          console.log(res);
          this.snackbar.content = '已解除封存';
          this.snackbar.color = 'success';
        })
        .catch((err) => {
          console.error(err);
          this.snackbar.content = '解除封存失敗';
          this.snackbar.color = 'error';
        })
        .finally(() => {
          this.snackbar.show = true;
          this.loading5 = false;
          this.getCommunityListApi();
        });
    },
    // #endregion
  },
};
</script>

<style>
.ellipsis {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  /* 控制顯示的行數 */
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
  /* 控制單詞的斷行方式 */
}
</style>
